<template>
  <p
    class="reach-bottom-text"
    :style="{height:height + 'px','line-height':height + 'px' }"
  >{{ text }}</p>
</template>

<script>
import i18n from '@/lang';

export default {
  name: 'NoDataPrompt',
  props: {
    text: {
      type: String,
      default: i18n.t('暂无数据')
    },
    height: {
      type: Number,
      default: 304
    }
  }
};
</script>

<style lang="scss" scoped>
.reach-bottom-text {
  width: 100%;
  font-size: 14px;
  text-align: center;

  color: #C0C4CC;
}
</style>
